"use client";

import Image from "next/image";
import { copyAndShare, openLink } from "@/utils/utils";

type Props = {
  title?: string;
  path?: string;
};

export const SnsLinks = (props: Props) => {
  const { title, path } = props;
  const getShareUrl = () => {
    if (typeof window === "undefined") return "";
    return path
      ? window.location.protocol + "//" + window.location.hostname + path
      : window.location.href;
  };

  return (
    <>
      <a
        href="#"
        onClick={(event) => {
          event.preventDefault();
          const shareUrl = getShareUrl();
          openLink(event, `http://www.facebook.com/share.php?u=${shareUrl}`);
        }}
      >
        <Image src="/icon/fb-icon.svg" alt="facebook" width={9} height={23} />
      </a>
      <a
        href="#"
        onClick={(event) => {
          event.preventDefault();
          const shareUrl = getShareUrl();
          openLink(
            event,
            `https://twitter.com/intent/tweet?url=${shareUrl}&text=${title}`
          );
        }}
      >
        <div style={{ width: "1rem", height: "1.1rem", position: "relative" }}>
          <Image
            src="/icon/x-icon.svg"
            alt="x"
            width={20}
            height={21}
            className="u-doubled-image"
          />
        </div>
      </a>
      <a
        href="https://www.instagram.com/"
        onClick={(event) => {
          event.preventDefault();
          const shareUrl = getShareUrl();
          copyAndShare(event, shareUrl);
        }}
      >
        <Image
          src="/icon/insta-icon.svg"
          alt="instagram"
          width={14}
          height={23}
        />
      </a>
      <a
        href="https://www.linkedin.com/feed/"
        onClick={(event) => {
          event.preventDefault();
          const shareUrl = getShareUrl();
          copyAndShare(event, shareUrl);
        }}
      >
        <Image
          src="/icon/linkedin-icon.svg"
          alt="linked-in"
          width={15}
          height={23}
        />
      </a>
    </>
  );
};
